module.exports = __webpack_public_path__ + "img/Watney3.f706ae53.svg";